import { GetEcoaStudySpecResponse } from "./Ecoa.dto";
import { EcoaUrl } from "./Ecoa.url";
import { restReq } from "../../common/cyan.types";
import { FxApiRequestData, FxRequestData } from "../../common/flax.types";

export class EcoaFlax {
  public static getEcoaStudySpec(data: FxRequestData<{}>): FxApiRequestData<GetEcoaStudySpecResponse> {
    return {
      ...restReq(process.env.REACT_APP_CDMS_BE_URL, EcoaUrl.getEcoaStudySpec(), data),
      reducer: resp => resp,
      errReducer: resp => resp,
    };
  }
}
